import api from './api';

const userService = {
  // Get all users
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/users', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  getAllUsers: async (params = {}) => {
    try {
      const response = await api.get('/users', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  // Get user by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user:', error);
      throw error;
    }
  },

  // Get users for dropdown (simplified data)
  getForDropdown: async () => {
    try {
      const response = await api.get('/users', {
        params: {
          limit: 1000, // Get all active users
          fields: 'id,first_name,last_name,email,avatar_url'
        }
      });
      
      const users = response.data.data || response.data.users || [];
      
      return users.map(user => ({
        value: user.id,
        label: `${user.first_name} ${user.last_name}`,
        email: user.email,
        avatar_url: user.avatar_url,
        fullName: `${user.first_name} ${user.last_name}`
      }));
    } catch (error) {
      console.error('Error fetching users for dropdown:', error);
      // Return empty array on error so dropdown doesn't break
      return [];
    }
  },

  // Format user name
  formatUserName: (user) => {
    if (!user) return 'Unknown User';
    if (user.first_name && user.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }
    return user.email || user.name || 'Unknown User';
  },

  // Get user initials for avatar
  getUserInitials: (user) => {
    if (!user) return '?';
    
    if (user.first_name && user.last_name) {
      return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();
    }
    
    if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }
    
    return '?';
  },

  // Get avatar color based on user ID
  getAvatarColor: (userId) => {
    if (!userId) return '#6B7280';
    
    const colors = [
      '#EF4444', '#F59E0B', '#10B981', '#3B82F6', 
      '#6366F1', '#8B5CF6', '#EC4899', '#14B8A6'
    ];
    
    // Simple hash function to get consistent color for user
    let hash = 0;
    for (let i = 0; i < userId.length; i++) {
      hash = userId.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  }
};

export default userService;


